/* Defines the user entity */
export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  telephone: string;
  teleExt: string;
  userName: string;
  permLevel: number;  
  updatedBy: string;
  updatedDate: string;
  token: string;
}

export function newUser():User{
  const u:User= {
    id: 0,
    firstName: null,
    lastName: null,
    email: null,
    telephone: null,
    teleExt: null,
    userName: null,
    updatedDate: null,
    permLevel: null,
    updatedBy: null,
    token: null,
  }
  return u;
}